import React from 'react';

const BarcodeCancellationComponentLoadable = React.lazy(() => import('./BarcodeCancellationComponent'));


export {
    BarcodeCancellationComponentLoadable
};
